function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }


document.addEventListener('DOMContentLoaded', function () {
    var targetNode = document.querySelector('.product-form__option-value');
    
    // Check if the target node is found
    if (targetNode) {
        console.log('.product-form__option-value found:', targetNode);
        sliderObserver(targetNode);
    } else {
        console.log('.product-form__option-value not found');
    }
}, false);

function sliderObserver(targetNode) {
    // Function to handle the existence of elements
    function handleElementsExistence() {
        var elements = document.querySelectorAll('#pwzrswiper-wrapper .pwzrswiper-slide');
        if (elements.length > 0) {
            console.log('Slides found, setting up variant change observer');
            variantChange(targetNode);
            getJson(); // Call your JSON function here
            observer.disconnect(); // Stop observing once elements are found
        } else {
            console.log('No slides found yet.');
        }
    }

    // Create a MutationObserver instance for the body
    var observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === 'childList') {
                console.log('DOM changed, checking for slides...');
                handleElementsExistence();
            }
        });
    });

    // Start observing the body for DOM changes
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });

    // Call initially to handle existing elements
    handleElementsExistence();
}

function variantChange(targetNode) {
    // Function to handle mutations for the target node
    function handleMutation(mutationsList) {
        mutationsList.forEach(mutation => {
            if (mutation.type === 'childList') {
                console.log('Changes detected in target node:', mutation);
                getJson(); // Call your JSON function here
            }
        });
    }

    var observer = new MutationObserver(handleMutation);
    
    // Observe the target node for specific changes
    observer.observe(targetNode, {
        childList: true,
        characterData: true,
        subtree: true
    });

    console.log('Observing changes to target node:', targetNode);
}



// document.addEventListener('DOMContentLoaded', function () {
//   var targetNode = document.querySelector('.product-form__option-value');
//   if (targetNode) {
//     sliderObserver(targetNode);
//   }
// }, false);
// function sliderObserver(targetNode) {
//   // Function to be called when elements are found
//   function handleElementsExistence() {
//     var elements = document.querySelectorAll('#pwzrswiper-wrapper .pwzrswiper-slide');
//     if (elements.length > 0) {
//       variantChange(targetNode);
//       getJson();
//       observer.disconnect();
//     }
//   }

//   // Create a MutationObserver instance
//   var observer = new MutationObserver(function (mutationsList, observer) {
//     // Check if any mutations are related to the appearance of the desired elements
//     var _iterator = _createForOfIteratorHelper(mutationsList),
//       _step;
//     try {
//       for (_iterator.s(); !(_step = _iterator.n()).done;) {
//         var mutation = _step.value;
//         if (mutation.type === 'childList') {
//           handleElementsExistence();
//         }
//       }
//     } catch (err) {
//       _iterator.e(err);
//     } finally {
//       _iterator.f();
//     }
//   });

//   // Start observing the target node for DOM changes
//   observer.observe(document.body, {
//     childList: true,
//     // Watch for changes in the child nodes of the body
//     subtree: true // Watch for changes in the entire subtree
//   });

//   // Call the function initially in case the elements are already there
//   handleElementsExistence();
// }
// function variantChange(targetNode) {
//   function handleMutation(mutationsList, observer) {
//     var _iterator2 = _createForOfIteratorHelper(mutationsList),
//       _step2;
//     try {
//       for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
//         var mutation = _step2.value;
//         if (mutation.type === 'childList') {
//           getJson();
//         }
//       }
//     } catch (err) {
//       _iterator2.e(err);
//     } finally {
//       _iterator2.f();
//     }
//   }
//   var config = {
//     childList: true,
//     characterData: true,
//     subtree: true
//   };
//   var observer = new MutationObserver(handleMutation);
//   observer.observe(targetNode, config);
// }
function getJson() {
  var variants = document.getElementById('hide-pdp-images').textContent;
  var variantsObj = JSON.parse(variants);
  var activeVariant = document.querySelector('.product-form__option-value').textContent;
  console.log('activeVariant',activeVariant, variantsObj);
  // activeVariant = activeVariants.textContent;
  //var activeVariant;
  // if (activeVariants.length > 1) {
  //   activeVariants.forEach(function (variant, index) {
  //     if (index == 0) {
  //       activeVariant = variant.textContent;
  //     } else {
  //       activeVariant = activeVariant + ' / ' + variant.textContent;
  //     }
  //   });
  // } else {
  //   activeVariant = activeVariants[0].textContent;
  // }
  var matchingVariant = variantsObj.find(function (variant) {
    return variant.title === activeVariant;
  });
  console.log('matchingVariant',matchingVariant);
  if (matchingVariant) {
    var hide_images_a = matchingVariant.hide_images_a,
      hide_images_b = matchingVariant.hide_images_b,
      info_button = matchingVariant.info_button;
    hideImages("".concat(hide_images_a), "".concat(hide_images_b));
    parseInfoButtonData("".concat(info_button));
  }
}
function hideImages(a, b) {
  var thumbLSlider = document.querySelectorAll('.PwzrGrid-root.rio-hide-scrollbar.PwzrGrid-container.PwzrGrid-align-items-xs-center.PwzrGrid-justify-xs-center .PwzrGrid-root');
  var mainSlider = document.querySelectorAll('#pwzrswiper-wrapper .pwzrswiper-slide');
  if (a) {
    a = arrayValue = JSON.parse(a);
    a = a.map(function (value) {
      return value - 1;
    });
    a.forEach(function (index) {
      if (index < thumbLSlider.length) {
        thumbLSlider[index].classList.add('ed-ab-ju-21-a');
      }
      if (index < mainSlider.length) {
        mainSlider[index].classList.add('ed-ab-ju-21-a');
      }
    });
  }
  if (b) {
    b = arrayValue = JSON.parse(b);
    b = b.map(function (value) {
      return value - 1;
    });
    b.forEach(function (index) {
      if (index < thumbLSlider.length) {
        thumbLSlider[index].classList.add('ed-ab-ju-21-b');
      }
      if (index < mainSlider.length) {
        mainSlider[index].classList.add('ed-ab-ju-21-b');
      }
    });
  }
  clickOnVisibleElement();
}

function parseInfoButtonData(data) {
  // Split the data by the tilde to separate each segment

  console.log('data',data);
  
  var segments = data.split('~').filter(Boolean);

  var parsedData = segments.map(function (segment, index) {

    var parts = segment.split("|");

    var active = index === 0;

    var imageNumber = parseInt(parts[0].replace(/^[,]*/, '').replace(/[\[\]]/g, ''), 10); // Remove brackets and convert to number
    var title = parts[1] ? parts[1].trim() : null; // Handle optional title
    var text = parts[2] ? parts[2].trim() : null; // Handle optional text

    return {
      active: active, // Set active state
      imageNumber: imageNumber,
      title: title,
      text: text
    };
  });

  console.log('parsedData',parsedData)
  setTimeout(function(){
    addInfoButton(parsedData);
  },1000);
}

// function parseInfoButtonData(data) {
//   var segments = data.split(/,(?=1|0\|)/);
//  console.log('segments',segments);

//   // Parse each segment into objects
//   var parsedData = segments.map(function (segment) {
//     var _segment$split = segment.split("|"),
//       _segment$split2 = _slicedToArray(_segment$split, 3),
//       active = _segment$split2[0],
//       imageNumber = _segment$split2[0],
//       title = _segment$split2[1],
//       text = _segment$split2[2];
//     return {
//       active: parseInt(active, 10) === 1,
//       imageNumber: parseInt(imageNumber, 10),
//       title: title,
//       text: text
//     };
//   });
//   console.log('parsedData',parsedData);
//   addInfoButton(parsedData);
// }

function addInfoButton(data) {
  var mainSlider = document.querySelectorAll('#pwzrswiper-wrapper .pwzrswiper-slide');
  console.log(mainSlider);
  data.forEach(function (obj) {
    if (obj) {
      // Create new info button element
      var infoWrapper = document.createElement('div');
      infoWrapper.classList.add('ed-info-button__wrapper');
      infoWrapper.classList.add('product-info-button-container');
      infoWrapper.style.background = 'rgb(13, 13, 13)';
      // Create spans for the title, text and more info
      var titleSpan = document.createElement('div');
      titleSpan.classList.add('ed-info-button__title');
      titleSpan.classList.add('inner');
      var titleSpan_child = document.createElement('div');
      titleSpan_child.classList.add('info-title');
      titleSpan_child.textContent = obj.title;
      // Append spans to new div wrapper
      titleSpan.appendChild(titleSpan_child);
      infoWrapper.appendChild(titleSpan);
      if (obj.text.length > 1) {
        var textSpan = document.createElement('div');
        textSpan.classList.add('ed-info-button__text');
        textSpan.classList.add('info-content-container');
        textSpan.textContent = obj.text;
        var moreInfo = document.createElement('div');
        moreInfo.classList.add('ed-info-button__more-info');
        moreInfo.classList.add('info-icon');
        // moreInfo.textContent = "Mehr Infos";
        // Create info icon and append to moreInfo
        var infoIcon = document.createElement('div');
        infoIcon.innerHTML = '<i class="fa fa-circle-info"></i>';
        moreInfo.appendChild(infoIcon);
        // Append spans to new div wrapper
        infoWrapper.appendChild(moreInfo);
        infoWrapper.appendChild(textSpan);
      }
      // Append info button to slide
      var imageNumber = parseInt(obj.imageNumber - 1);
      mainSlider[imageNumber].appendChild(infoWrapper);
      console.log(imageNumber,mainSlider[imageNumber]);
    }
  });
  openInfoButtonDialog();
}
function openInfoButtonDialog() {
  var btns = document.querySelectorAll(".ed-info-button__more-info");
  btns.forEach(function (btn) {
    var text = btn.parentNode.querySelector(".ed-info-button__text");
    var showText = function showText() {
      text.classList.add("show");
    };
    var hideText = function hideText() {
      text.classList.remove("show");
    };

    // Desktop events
    btn.addEventListener("mouseenter", showText);
    btn.addEventListener("mouseleave", hideText);
    btn.addEventListener("click", showText);

    // Mobile events
    btn.addEventListener("touchstart", showText);
    btn.addEventListener("touchend", hideText);
  });
}
function clickOnVisibleElement() {
  var elements = document.querySelectorAll('.PwzrGrid-root.rio-hide-scrollbar.PwzrGrid-container.PwzrGrid-align-items-xs-center.PwzrGrid-justify-xs-center .PwzrGrid-root');
  var _iterator3 = _createForOfIteratorHelper(elements),
    _step3;
  try {
    var _loop = function _loop() {
      var element = _step3.value;
      var computedStyle = window.getComputedStyle(element);
      var displayValue = computedStyle.getPropertyValue('display');
      if (displayValue != 'none') {
        setTimeout(function () {
          element.querySelector('div').click();
        }, 50);
        return "break";
      }
    };
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ret = _loop();
      if (_ret === "break") break;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}